import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {networkDeviceActions} from "../../../actions/network-device.actions";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import NetworkDeviceContentActivityTable from "./_components/NetworkDeviceContentActivityTable";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../actions/modal.actions";
import NetworkDeviceContentActivityDeleteLogs from "./_forms/NetworkDeviceContentActivityDeleteLogs";
import {networkDeviceContentService} from "../../../services/network-device-content.service";

class NetworkDeviceContentActivityPage extends Component {

    state = {
        networkDeviceId: null,
        refresh: false
    };

    componentDidMount() {
        const id = this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(id));

        this.setState({
            networkDeviceId: id,
        });
    }

    deleteLogsSubmit = (dates) => {
        const { networkDeviceId } = this.state;
        networkDeviceContentService.deleteActivityLogs(networkDeviceId, dates)
            .then(
                (res) => {
                    this.closeModal();
                    window.location.reload(false);
                },
                err => {
                    console.log(err)
                }
            )
    }

    openClearLogModal = () => {
        const { dispatch, t } = this.props;
        const modalProps = {
            open: true,
            title: t('delete-logs'),
            component: <NetworkDeviceContentActivityDeleteLogs onSubmit={this.deleteLogsSubmit}/>
        };
        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: "formModal"
        }));
    }

    closeModal = () => {
        const { dispatch } = this.props;
        dispatch(modalActions.hideModal());
    }


    render() {
        const { t, simpleDeviceInfo } = this.props;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: 'network-device-content', path: '#' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: 'content-activity-log', path: '#' }
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <div className="col-md-3">
                        <h3>{ t('content-activity-log') }</h3>
                        <h5 className='font-italic'>{simpleDeviceInfo?.label}</h5>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to={"/panel/network-device/content/" + simpleDeviceInfo?.id } className="btn btn-secondary float-right" >
                                <i className="fas fa-undo"> </i>
                                <span> {t('back-to-list')} </span>
                            </Link>

                            <Button variant={"danger"} onClick={this.openClearLogModal}>
                                <i className="fas fa-trash"/> &nbsp;
                                {t('delete-logs')}
                            </Button>
                        </div>
                    </div>
                    <div className="card-body">
                        { simpleDeviceInfo ? (<NetworkDeviceContentActivityTable networkDeviceId={simpleDeviceInfo.id} />) : (<React.Fragment/>) }
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { simpleDeviceInfo } = state.networkDeviceReducer;
    return {
         simpleDeviceInfo
    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceContentActivityPage));
